export default "__VITE_ASSET__BKs6PrRE__"